export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Editar" },
    { key: "2", label: "Excluir" },
  ];
};
